module.exports = __webpack_public_path__ + "img/deditos_de_pescao.9657a3d3.jpg";